<div class="summary-part"
     *ngIf="!cs.step2.skipped">
    <div class="summary-part-title">
        <div class="title">{{ 'ITSM.CREATESERVICEREQUEST.STEPS.STEP2.TAB' | translate }}</div>
        <div class="action"
             (click)="gotoStep(1)">{{ 'BUTTON.MODIFY' | translate }}</div>
    </div>
    <ng-container *ngIf="cs.step2.valid">
        <div class="summary-part-row"
             *ngFor="let answer of cs.step2.answers">
            <div class="summary-field label">{{ answer.question.label[this.language] }}</div>
            <div class="summary-field value"
                 [innerHtml]="answer.response"></div>
        </div>
    </ng-container>
    <ng-container *ngIf="!cs.step2.valid">
        <div class="summary-part-row">
            {{ 'ITSM.CREATESERVICEREQUEST.STEPS.NOTCOMPLETED' | translate }}
        </div>
    </ng-container>
    <hr />
</div>
